import React from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../utils/util'

// Shown when an IT Access user tries to open a screen outside User Management.
// IT Access is intentionally limited to user management; every other route
// redirects here.
const NoPermission = () => {
    usePageTitle('Upstrive Education - No permission')
    const history = useHistory()
    const { t } = useTranslation()

    return (
        <div className='flex justify-center items-center w-full h-screen bg-deepPurple flex-col absolute z-50'>
            <p className='text-highlightColor text-[28px] font-semibold text-center px-10 mb-4'>
                {t('noPermissionTitle')}
            </p>
            <p className='text-highlightColor text-[16px] text-center px-10 mb-10 opacity-80'>
                {t('noPermissionSubtitle')}
            </p>
            <button
                className='h-[60px] px-[40px] rounded-[100px] font-semibold text-[18px] bg-highlightColor text-deepPurple hover:opacity-90 cursor-pointer'
                onClick={() => history.push('/management')}
            >
                {t('goToUserManagement')}
            </button>
        </div>
    )
}

export default NoPermission
